export default __webpack_public_path__ + "static/majestic-ireland-homepage-loop-5df4bde7cc34206a353c7faaf5d13afe.mp4";